import Header from "../component/Nevbar";
import Footer from "../component/Footer";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Pagination from "../component/Pagination";
import Spinner from "../component/Spinner";
import { useLanguage } from "../context/LanguageContext";

const Blog = () => {
  const { language, fontFamilyStyle, lang } = useLanguage();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [blogCount, setBlogCount] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  // Effect to add sticky class on scroll
  useEffect(() => {
    const header = document.querySelector(".page-header");
    const toggleClass = "is-sticky";
    const handleScroll = () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 150) {
        header.classList.add(toggleClass);
      } else {
        header.classList.remove(toggleClass);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Effect to fetch blog data from API
  useEffect(() => {
    setLoading(true);
    axios
      .post(
        "https://reactapi.khatt.app/api/v1/school/common/get_blog_web",
        {
          page: page,
          per_page: 9,
          search: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "api-key": "QvDRU0lXzsx8qdoU3Ryv1g==",
          },
        }
      )
      .then((response) => {
        setBlogs(response.data.data);
        setBlogCount(response.data.data[0].blog_count);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError("An error occurred while fetching the blogs.");
      });
  }, [page, searchTerm]);

  const handleReadMore = (blog) => {
    // Store blog in sessionStorage for refresh resilience
    sessionStorage.setItem(`blog_${blog.id}`, JSON.stringify(blog));
    navigate(`/${lang}/blog/${blog.id}`);
  };

  return (
    <>
      <Helmet>
        <html lang={lang === "en" ? "en" : "ar"} dir={lang === "en" ? "ltr" : "rtl"} />
        <title>
          {language === "Arabic"
            ? "مدونة خط - مقالات عن تعلم الخط العربي | Khat Blog"
            : "Learn Arabic Writing — Tips, Guides & Tutorials | Khat App Blog"}
        </title>
        <meta
          name="description"
          content={
            language === "Arabic"
              ? "مدونة تطبيق خط - مقالات ونصائح لتعلم وتحسين الخط العربي، خط الرقعة وخط النسخ."
              : "Articles and guides on learning Arabic writing, Arabic letter connections, handwriting practice tips, and step-by-step Arabic alphabet tutorials."
          }
        />
        <link rel="canonical" href={`https://khatt.app/${lang}/blog`} />
        <link rel="alternate" hreflang="ar" href="https://khatt.app/ar/blog" />
        <link rel="alternate" hreflang="en" href="https://khatt.app/en/blog" />
        <link rel="alternate" hreflang="x-default" href="https://khatt.app/ar/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://khatt.app/${lang}/blog`} />
        <meta
          property="og:title"
          content={
            language === "Arabic"
              ? "مدونة خط - مقالات عن تعلم الخط العربي"
              : "Learn Arabic Writing — Tips, Guides & Tutorials | Khat App Blog"
          }
        />
        <meta
          property="og:description"
          content={
            language === "Arabic"
              ? "مدونة تطبيق خط - مقالات ونصائح لتعلم وتحسين الخط العربي."
              : "Articles and guides on learning Arabic writing, Arabic letter connections, handwriting practice tips, and step-by-step Arabic alphabet tutorials."
          }
        />
        <meta property="og:image" content="https://khatt.app/assets/imges/logo.svg" />
      </Helmet>
      <Header />
      <section className="pt-5 pb-5">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-lg-3 mb-4">
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder={
                    language === "Arabic" ? "يبحث...." : "Search...."
                  }
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Replace the default loading indicator with the Spinner component */}
          {loading && <Spinner message="Loading blogs..." isActive={loading} />}
          {error && <p>{error}</p>}

          {/* Render blogs */}
          <div className="row">
            {blogs.length === 0 ? (
              <h1 className="text-center w-100" style={{ color: "white" }}>
                No blogs found
              </h1>
            ) : (
              blogs.map((blog) => (
                <div key={blog.id} className="col-lg-4 col-md-6 col-sm-6 mb-4">
                  <div className="blog-card">
                    <div className="blog-img">
                      <img src={blog.blog_image} alt="image" />
                    </div>
                    {language === "Arabic" ? (
                      <div
                        className="blog-details"
                        style={{
                          direction: "rtl",
                          fontFamily: fontFamilyStyle,
                        }}
                      >
                        <p className="text-white mb-3">
                          <i className="fa-regular fa-calendar-days pe-2"></i>
                          {new Date(blog.insertdate).toLocaleDateString("ar-EG")}
                        </p>
                        <h4
                          className="title"
                          style={{ fontFamily: fontFamilyStyle }}
                        >
                          {blog.ar_title}
                        </h4>
                        <p>{blog.excerpt}</p>
                        <button
                          className="invite_btn blue_bg text-white mt-3"
                          onClick={() => handleReadMore(blog)}
                        >
                          اقرأ المزيد
                        </button>
                      </div>
                    ) : (
                      <div
                        className="blog-details"
                        style={{ fontFamily: fontFamilyStyle }}
                      >
                        <p className="text-white mb-3">
                          <i className="fa-regular fa-calendar-days pe-2"></i>
                          {new Date(blog.insertdate).toLocaleDateString()}
                        </p>
                        <h4 className="title">{blog.title}</h4>
                        <p>{blog.excerpt}</p>
                        <button
                          className="invite_btn blue_bg text-white mt-3"
                          onClick={() => handleReadMore(blog)}
                        >
                          Read more
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
            <Pagination
              per_page={9}
              pageCount={blogCount}
              onPageChange={handlePageChange}
              page={page}
              lableName={`Blog`}
            />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Blog;
